import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

// `suffix` is a server-supplied marker printed after the amount — "+ Fuel costs"
// on a launch estimate whose fill-up has not been pumped yet. The caller decides
// whether a row carries one; this only prints it.
const Total = ({
  label,
  amount,
  suffix = null,
  loading,
  currency = "USD",
  variant = "default",
}) => {
  const classes = classNames("flex", "items-center", "justify-between", {
    "text-red-600 font-semibold": variant === "red",
    "text-gray-900": variant === "default",
  })

  return (
    <div className={classes}>
      <span className="font-semibold">{label}</span>
      <div className="h-6">
        {loading ? (
          <i className="fa-solid fa-spinner-third fa-spin h-full" />
        ) : (
          <span className="text-lg font-semibold">
            {formatCurrencyFromMinorUnits({ amount, currency })}
            {suffix ? ` ${suffix}` : null}
          </span>
        )}
      </div>
    </div>
  )
}

Total.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  suffix: PropTypes.string,
  loading: PropTypes.bool,
  currency: PropTypes.string,
  variant: PropTypes.string,
}

export default Total
